import { useEffect, useState } from "react";
import {
  MenuItem,
  Select,
  Button,
  CardHeader,
  DataGrid,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from "../../../components";
import {
  ManifestacaoDestinatarioService,
  notification,
} from "../../../services";
import shortid from "shortid";
import { responseErros } from "../../../utils";
import CertificadoDigitalService from "../../../services/api/certificado-digital.service";

const RegistroEventoDialog = ({
  open,
  setOpen,
  empresa,
  selectionModel,
  setSelectionModel,
  notasManifestacao,
  buscarManifestacaoDestinatario,
  setLoading,
}) => {
  const [notas, setNotas] = useState([]);
  const [evento, setEvento] = useState(null);
  const [justificativa, setJustificativa] = useState(null);
  const [erros, setErros] = useState([]);

  const manifestacaoDestinatarioService = new ManifestacaoDestinatarioService();
  const certificadoDigitalService = new CertificadoDigitalService();

  const colunas = [
    {
      field: "razaoSocial",
      headerName: "Fornecedor",
      flex: 200,
      sortable: false,
    },
    {
      field: "chaveXml",
      headerName: "Chave XML",
      flex: 200,
      sortable: false,
    },
  ];

  const eventos = [
    {
      label: "Confirmação da Operação",
      color: "#4FBB53",
      value: 210200,
    },
    {
      label: "Ciência da Emissão",
      color: "#004780",
      value: 210210,
    },
    {
      label: "Desconhecimento da Operação",
      color: "#DC3545",
      value: 210220,
    },
    {
      label: "Operação não Realizada",
      color: "#EA9D2B",
      value: 210240,
    },
  ];

  useEffect(() => {
    const notasFiltradas = notasManifestacao.filter(({ id }) =>
      selectionModel.includes(id),
    );
    setNotas(notasFiltradas);
  }, [open]);

  function handleClose() {
    setEvento(null);
    setJustificativa(null);
    setOpen(false);
  }

  async function handleSubmit() {
    setErros([]);
    if (!evento) {
      setErros((prev) => [...prev, 'evento']);
      notification.alertaGenericos(
        "É obrigatório escolher um evento para o registro da manifestação",
      );
      return;
    }
    if (evento === 210240 && !justificativa) {
      setErros((prev) => [...prev, 'justificativa']);
      notification.alertaGenericos(
        "Informe o motivo referente à operação não realizada",
      );
      return;
    }
    setLoading(true);
    const result = await certificadoDigitalService.consultar(empresa.cnpjCpf);
    if (!result.isAxiosError) {
      const chaves = notas.map(({ chaveXml }) => chaveXml);
      const res = await manifestacaoDestinatarioService.registrarEvento({
        chaves,
        evento,
        justificativa,
        certificadoSenha: result.data.certificadoSenha,
      });
      if (!res.isAxiosError) {
        notification.sucessoGenericos("Evento registrado com sucesso");
      } else {
        responseErros(res);
      }
    } else {
      responseErros(result);
    }
    setLoading(false);
    buscarManifestacaoDestinatario();
    setSelectionModel([]);
    handleClose();
  }

  return (
    <Dialog fullWidth maxWidth={"md"} open={open} onClose={handleClose}>
      <CardHeader title="Registro de Eventos" className="m-2" />
      <DialogContent>
        <div className="mb-2">
          <DataGrid
            rows={notas}
            columns={colunas}
            rowCount={notas.length}
            disableAcoes
          />
        </div>
        <Select
          id="evento"
          name="evento"
          value={evento}
          label="Evento"
          onChange={(e) => setEvento(e.target.value)}
          fullWidth
          required
          className="mt-4 mb-2"
          error={erros.includes('evento')}
        >
          {eventos.map((item) => (
            <MenuItem key={shortid.generate()} value={item.value}>
              <i
                className="ph-fill ph-circle"
                style={{ color: item.color }}
              ></i>
              &nbsp;&nbsp;{item.label}
            </MenuItem>
          ))}
        </Select>
        {evento === 210240 && (
          <TextField
            variant="outlined"
            id="justificativa"
            name="justificativa"
            label="Justificativa"
            type="text"
            margin="normal"
            fullWidth
            required
            className="mt-4"
            onChange={(e) => setJustificativa(e.target.value)}
            value={justificativa}
            error={erros.includes('justificativa')}
          />
        )}
      </DialogContent>
      <DialogActions className="m-2 gap-2">
        <Button color="primary" variant="contained" onClick={handleSubmit}>
          <i
            className="ph-fill ph-check-circle"
            style={{ fontSize: 22, marginRight: 10, color: "white" }}
          ></i>
          Registrar
        </Button>
        <Button color="padrao" variant="contained" onClick={handleClose}>
          <i
            className="ph-fill ph-x-circle"
            style={{ fontSize: 22, marginRight: 10 }}
          ></i>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RegistroEventoDialog;
